import React, { createContext, useContext, useState, useEffect } from 'react';
import { INITIAL, COLORS, COLORS_L2, COLORS_D2 } from '../../constants';
import {
  getListName,
  getListColor,
  getListColor_L2,
  getListColor_D2
} from '../../helpers';
import { useAllInOneContext } from '..';

const ActiveListContext = createContext();

export const ActiveListProvider = ({ children }) => {
  const [activeList, setActiveList] = useState(INITIAL);

  const { lists } = useAllInOneContext();
  const [listName, setListName] = useState();
  const [themeColor, setThemeColor] = useState(COLORS[0]);
  const [themeColor_L2, setThemeColor_L2] = useState(COLORS_L2[0]);
  const [themeColor_D2, setThemeColor_D2] = useState(COLORS_D2[0]);

  useEffect(() => {
    if (activeList && activeList != '' && activeList != INITIAL) {
      const name = getListName(activeList, lists);

      setListName(name);
      document.title = `${name} | Ame`;
      setThemeColor(getListColor(activeList, lists));
      setThemeColor_L2(getListColor_L2(activeList, lists));
      setThemeColor_D2(getListColor_D2(activeList, lists));
    }
  }, [activeList]);

  return (
    <ActiveListContext.Provider
      value={{
        activeList,
        setActiveList,
        listName,
        themeColor,
        themeColor_L2,
        themeColor_D2
      }}
    >
      {children}
    </ActiveListContext.Provider>
  );
};

export const useActiveListContext = () => useContext(ActiveListContext);
